<template lang="html">
  <section class="section">
    <div class="container">
      <div class="columns is-multiline">
        <div class="column is-6">
          <h1 class="title">Walkers</h1>
          <figure class="image">
            <img src="static/images/walkers/walkers_01.jpg" />
          </figure>
        </div>
        <div class="column is-6" style="margin-top: 55px">
          <p class="title">
            Walkers are a family of side tables made from parquet floor
            leftovers.
          </p>
          <p>
            The base of my design work was the dimensions of Timberwise parquet
            planks and the lively wooden surface. The intersecting surfaces
            resulted in a sturdy structure and playful appearance for the
            Walkers. In my design work, I wanted to explore the asymmetry that
            contributed to the idea of the product’s versatility: By turning the
            Walkers into different positions, their purpose can also be changed.
            Produced by Timberwise, Finland
          </p>
          <br />
          <p>Photography: Mikko Ryhänen</p>
        </div>
        <div class="column is-6">
          <figure class="image">
            <img src="static/images/walkers/walkers_02.jpg" />
          </figure>
        </div>
        <div class="column is-6">
          <figure class="image">
            <img src="static/images/walkers/walkers_03.jpg" />
          </figure>
        </div>
        <div class="column is-6">
          <figure class="image">
            <img src="static/images/walkers/walkers_04.jpg" />
          </figure>
        </div>
        <div class="column is-6">
          <figure class="image">
            <img src="static/images/walkers/walkers_05.jpg" />
          </figure>
        </div>
        <div class="column is-6">
          <figure class="image">
            <img src="static/images/walkers/walkers_06.jpg" />
          </figure>
        </div>
        <div class="column is-6">
          <figure class="image">
            <img src="static/images/walkers/walkers_07.jpg" />
          </figure>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import mediumZoom from "medium-zoom";

export default {
  mounted() {
    mediumZoom(".zoom-default");
  },
};
</script>

<style lang="css"></style>



// WEBPACK FOOTER //
// src/components/portfolio/work/Walkers.vue